let headerNavigationCleanup;

function initHeaderNavigation() {
  if (headerNavigationCleanup) {
    headerNavigationCleanup();
  }

  const header = document.querySelector("#header-group .header");

  if (!header) {
    headerNavigationCleanup = undefined;
    return;
  }

  const controller = new AbortController();
  const { signal } = controller;
  const desktopMenu = header.querySelector("[data-desktop-menu]");
  const mobileMenu = header.querySelector("[data-mobile-menu]");
  const mobileToggle = header.querySelector("[data-mobile-menu-toggle]");
  const closeTimers = new Map();

  function updateDesktopBackdrop() {
    const hasOpenMenu = Boolean(desktopMenu?.querySelector("[data-menu-toggle][aria-expanded='true']"));

    if (hasOpenMenu) {
      const headerBottom = Math.max(header.getBoundingClientRect().bottom, 0);

      document.body.style.setProperty("--header-menu-backdrop-top", `${headerBottom}px`);
      document.body.setAttribute("data-header-menu-open", "true");
    } else {
      document.body.style.removeProperty("--header-menu-backdrop-top");
      document.body.removeAttribute("data-header-menu-open");
    }
  }

  function setDesktopMenuState(toggle, expanded) {
    const panel = document.getElementById(toggle.getAttribute("aria-controls"));

    toggle.setAttribute("aria-expanded", String(expanded));

    if (panel) {
      panel.hidden = !expanded;
    }

    updateDesktopBackdrop();
  }

  function closeDesktopMenus(exceptToggle) {
    if (!desktopMenu) return;

    desktopMenu.querySelectorAll("[data-menu-toggle]").forEach((toggle) => {
      if (toggle === exceptToggle) return;

      clearTimeout(closeTimers.get(toggle));
      closeTimers.delete(toggle);
      setDesktopMenuState(toggle, false);
    });
  }

  if (desktopMenu) {
    desktopMenu.querySelectorAll("[data-menu-toggle]").forEach((toggle) => {
      const item = toggle.closest(".header-nav-item");

      function openMenu() {
        clearTimeout(closeTimers.get(toggle));
        closeTimers.delete(toggle);
        setDesktopMenuState(toggle, true);
        closeDesktopMenus(toggle);
      }

      function scheduleClose() {
        clearTimeout(closeTimers.get(toggle));
        closeTimers.set(toggle, window.setTimeout(() => {
          setDesktopMenuState(toggle, false);
          closeTimers.delete(toggle);
        }, 120));
      }

      item.addEventListener("mouseenter", openMenu, { signal });
      item.addEventListener("mouseleave", scheduleClose, { signal });
      item.addEventListener("focusin", openMenu, { signal });
      item.addEventListener("focusout", (event) => {
        if (!item.contains(event.relatedTarget)) {
          scheduleClose();
        }
      }, { signal });

      if (toggle.tagName === "BUTTON") {
        toggle.addEventListener("click", () => {
          const expanded = toggle.getAttribute("aria-expanded") === "true";
          setDesktopMenuState(toggle, !expanded);
        }, { signal });
      }

      toggle.addEventListener("keydown", (event) => {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          openMenu();
          document.getElementById(toggle.getAttribute("aria-controls"))?.querySelector("a, button")?.focus();
        }

        if (event.key === "Escape") {
          event.preventDefault();
          setDesktopMenuState(toggle, false);
        }
      }, { signal });
    });

    desktopMenu.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;

      const panel = event.target.closest("[data-menu-panel]");
      const toggle = panel?.previousElementSibling;

      if (toggle?.matches("[data-menu-toggle]")) {
        setDesktopMenuState(toggle, false);
        toggle.focus();
      }
    }, { signal });
  }

  function updateMobileMenuTop() {
    const headerRect = header.getBoundingClientRect();
    mobileMenu?.style.setProperty("--mobile-menu-top", `${Math.max(headerRect.bottom, 0)}px`);
  }

  function resetMobileSubmenus() {
    mobileMenu?.querySelectorAll("[data-submenu-toggle]").forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });
    mobileMenu?.querySelectorAll("[data-submenu]").forEach((submenu) => {
      submenu.classList.remove("is-opening", "is-closing");
      submenu.hidden = true;
    });
  }

  function openMobileSubmenu(toggle, submenu) {
    toggle.setAttribute("aria-expanded", "true");
    submenu.classList.remove("is-closing");
    submenu.hidden = false;
    submenu.getBoundingClientRect();
    submenu.classList.add("is-opening");

    submenu.addEventListener("animationend", () => {
      submenu.classList.remove("is-opening");
      submenu.style.transform = "translateX(0)";
      submenu.querySelector("button, a")?.focus();
    }, { once: true, signal });
  }

  function closeMobileSubmenu(toggle, submenu) {
    submenu.classList.remove("is-opening");
    submenu.style.transform = "";
    submenu.classList.add("is-closing");

    submenu.addEventListener("animationend", () => {
      toggle.setAttribute("aria-expanded", "false");
      submenu.classList.remove("is-closing");
      submenu.hidden = true;
      toggle.focus();
    }, { once: true, signal });
  }

  function closeMobileMenu(restoreFocus = false) {
    if (!mobileMenu || !mobileToggle) return;

    mobileToggle.setAttribute("aria-expanded", "false");
    mobileMenu.hidden = true;
    document.body.removeAttribute("data-mobile-menu-open");
    resetMobileSubmenus();
    header.querySelectorAll(".header-inner-mobile a, .header-inner-mobile button").forEach((element) => {
      element.removeAttribute("tabindex");
    });

    if (restoreFocus) {
      mobileToggle.focus();
    }
  }

  function openMobileMenu() {
    if (!mobileMenu || !mobileToggle) return;

    closeDesktopMenus();
    updateMobileMenuTop();
    mobileToggle.setAttribute("aria-expanded", "true");
    mobileMenu.hidden = false;
    document.body.setAttribute("data-mobile-menu-open", "true");
    header.querySelectorAll(".header-inner-mobile a, .header-inner-mobile button").forEach((element) => {
      if (element !== mobileToggle) {
        element.setAttribute("tabindex", "-1");
      }
    });
  }

  if (mobileMenu && mobileToggle) {
    mobileToggle.addEventListener("click", () => {
      if (mobileToggle.getAttribute("aria-expanded") === "true") {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    }, { signal });

    mobileMenu.querySelectorAll("[data-submenu-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const submenu = document.getElementById(toggle.getAttribute("aria-controls"));

        if (!submenu) return;

        openMobileSubmenu(toggle, submenu);
      }, { signal });
    });

    mobileMenu.querySelectorAll("[data-submenu-back]").forEach((button) => {
      button.addEventListener("click", () => {
        const submenu = button.closest("[data-submenu]");
        const toggle = submenu?.previousElementSibling;

        if (!submenu || !toggle) return;

        closeMobileSubmenu(toggle, submenu);
      }, { signal });
    });

    mobileMenu.addEventListener("click", (event) => {
      if (event.target.closest("a, [data-toggle='search-dialog']")) {
        closeMobileMenu();
      }
    }, { signal });
  }

  document.addEventListener("click", (event) => {
    if (desktopMenu && !desktopMenu.contains(event.target)) {
      closeDesktopMenus();
    }
  }, { signal });

  document.addEventListener("keydown", (event) => {
    if (mobileToggle?.getAttribute("aria-expanded") !== "true") return;

    if (event.key === "Tab") {
      const visibleFocusableElements = Array.from(mobileMenu.querySelectorAll("a, button"))
        .filter((element) => !element.closest("[hidden]"));
      const firstElement = mobileToggle;
      const lastElement = visibleFocusableElements.at(-1);

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement?.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
      return;
    }

    if (event.key !== "Escape") return;

    const visibleSubmenus = Array.from(mobileMenu.querySelectorAll("[data-submenu]"))
      .filter((submenu) => !submenu.hidden);
    const activeSubmenu = visibleSubmenus.at(-1);

    if (activeSubmenu) {
      const toggle = activeSubmenu.previousElementSibling;
      closeMobileSubmenu(toggle, activeSubmenu);
    } else {
      closeMobileMenu(true);
    }
  }, { signal });

  window.addEventListener("resize", () => {
    if (document.body.getAttribute("data-header-menu-open") === "true") {
      updateDesktopBackdrop();
    }

    if (window.innerWidth >= 1200) {
      closeMobileMenu();
    } else if (mobileToggle?.getAttribute("aria-expanded") === "true") {
      updateMobileMenuTop();
    }
  }, { signal });

  window.addEventListener("scroll", () => {
    if (document.body.getAttribute("data-header-menu-open") === "true") {
      updateDesktopBackdrop();
    }

    if (mobileToggle?.getAttribute("aria-expanded") === "true") {
      updateMobileMenuTop();
    }
  }, { passive: true, signal });

  headerNavigationCleanup = () => {
    controller.abort();
    closeTimers.forEach((timer) => clearTimeout(timer));
    closeTimers.clear();
    document.body.style.removeProperty("--header-menu-backdrop-top");
    document.body.removeAttribute("data-header-menu-open");
    document.body.removeAttribute("data-mobile-menu-open");
    headerNavigationCleanup = undefined;
  };
}

initHeaderNavigation();
window.addEventListener("shopify:section:load", initHeaderNavigation);
